"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("utils/constants");
const containerStyle = {
    position: 'fixed',
    zIndex: constants_1.fixedZIndex.modal,
    paddingTop: '100px',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    overflow: 'auto',
    backgroundColor: 'rgba(0,0,0,0.4)'
};
const contentStyle = {
    backgroundColor: '#fefefe',
    margin: 'auto',
    width: 'auto',
    borderRadius: '10px',
    padding: '10px'
};
const errorContentStyle = theme => ({
    width: 432,
    height: 376,
    padding: 24,
    margin: 'auto',
    display: 'grid',
    borderRadius: 10,
    placeItems: 'center',
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white,
});
const errorIconStyle = {
    width: '182px',
    height: '188px'
};
const errorMessageStyle = {
    fontSize: 20,
    marginTop: '10px',
    textAlign: 'center',
    marginBottom: '10px',
    wordBreak: 'break-all'
};
const errorSubjectStyle = {
    fontSize: '12px',
    marginTop: '10px',
    marginBottom: '10px',
    textAlign: 'center',
    color: constants_1.color.redDark
};
const errorObjectStyle = {
    fontSize: '12px',
    fontWeight: 700,
    marginTop: '10px',
    marginBottom: '10px',
    textAlign: 'center',
};
const buttonSuccess = {
    padding: '8px 45px',
    borderRadius: '5px',
    backgroundColor: constants_1.color.buttonDark,
};
const buttonError = theme => ({
    padding: '8px 45px',
    borderRadius: '5px',
    backgroundColor: theme === 'dark' ? constants_1.color.buttonDark : constants_1.color.redDark,
});
const confirmContentStyle = theme => ({
    width: 432,
    height: 376,
    margin: 'auto',
    borderRadius: 10,
    padding: 24,
    display: 'grid',
    placeItems: 'center',
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white,
});
const buttonConfirm = theme => ({
    padding: '8px 45px',
    borderRadius: '5px',
    backgroundColor: theme === 'dark' ? constants_1.color.buttonDark : constants_1.color.redDark,
});
const buttonConfirmWrapper = {
    display: 'flex',
    justifyContent: 'space-around'
};
const buttonReset = {
    padding: '8px 45px',
    borderRadius: '5px',
    backgroundColor: '#FFC700',
};
const buttonResetWrapper = {
    display: 'flex',
    justifyContent: 'space-around'
};
const confirmIconStyle = {
    width: '187px',
    height: '193px'
};
const modalHeader = {
    display: 'flex',
    justifyContent: 'space-between',
    fontWeight: 'bold',
    alignItems: 'flex-start',
    marginBottom: 24
};
const modalTitle = theme => ({
    margin: 0,
    fontSize: 20,
    lineHeight: '30px',
    color: theme === 'light' ? '#404041' : constants_1.color.white,
});
const modalSubtitle = {
    margin: 0,
    fontWeight: 400,
    lineHeight: '24px',
    color: constants_1.color.softGrey,
    wordBreak: 'break-all'
};
const chooseUploadTypeWrapper = {
    display: 'flex',
    justifyContent: 'space-between'
};
const chooseUploadTypeCard = theme => ({
    width: 242,
    height: 213,
    padding: 24,
    display: 'flex',
    borderRadius: 10,
    cursor: 'pointer',
    color: constants_1.color.white,
    alignItems: 'center',
    alignContent: 'center',
    flexDirection: 'column',
    backgroundColor: theme === 'light' ? constants_1.color.redDark : constants_1.color.buttonDark
});
const uploadTypeText = {
    margin: 0,
    fontSize: 14,
    marginTop: 15,
    fontWeight: 400,
};
const uploadText = {
    margin: 0,
    width: 138,
    fontSize: 14,
    marginTop: 15,
    fontWeight: 400,
};
const browseText = {
    color: '#2CBCDD',
    textDecoration: 'underline'
};
const uploadOuterWrapper = {
    display: 'flex',
    flexDirection: 'column'
};
const uploadZoneWrapper = {
    width: '100%',
    height: 220,
    display: 'flex',
    borderRadius: 10,
    marginBottom: 24,
    alignItems: 'center',
    justifyContent: 'center',
    border: '2px dashed #DEE0E5',
};
const uploadResultWrapper = {
    width: '100%',
    display: 'flex',
    borderRadius: 10,
    alignItems: 'flex-start',
    flexDirection: 'column',
    justifyContent: 'center',
};
const uploadDocWrapper = {
    width: 350,
    height: '100%',
    fontSize: 14,
    display: 'flex',
    cursor: 'pointer',
    textAlign: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
};
const uploadSingleCardWrapper = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
};
const uploadDoubleCardWrapper = {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
};
const uploadTitle = {
    margin: 0,
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 8,
    lineHeight: '24px',
};
const buttonSave = (color) => ({
    height: 40,
    display: 'flex',
    borderRadius: 8,
    padding: '12px 20px',
    alignItems: 'center',
    backgroundColor: color,
});
const buttonTitle = {
    margin: 0,
    fontSize: 16,
    marginLeft: 8,
    fontWeight: '500',
    lineHeight: '24px'
};
const downloadTemplate = theme => ({
    height: 40,
    display: 'flex',
    borderRadius: 8,
    marginRight: 12,
    fontSize: 'large',
    padding: '12px 20px',
    fontWeight: 'normal',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme === 'dark' ? constants_1.color.black : constants_1.color.white,
    borderColor: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    backgroundColor: theme === 'dark' ? constants_1.color.sidebarItemDark : '#404041',
});
const documentsOuterWrapper = {
    width: '100%',
    marginBottom: 14,
};
const buttonWrapper = {
    width: '100%',
    display: 'flex'
};
const documentsInnerWrapper = {
    display: 'flex',
    marginBottom: 10,
    position: 'relative',
    alignItems: 'flex-start',
};
const documentsFilename = {
    display: 'flex',
    marginBottom: 4
};
const progressBar = {
    height: 4,
    width: '100%',
    borderRadius: 10,
    backgroundColor: constants_1.color.redDark
};
const filenameWrapper = {
    width: 270,
    marginLeft: 12
};
const filenameText = theme => ({
    margin: 0,
    fontSize: 14,
    maxWidth: 175,
    marginRight: 8,
    fontWeight: 400,
    overflow: 'hidden',
    lineHeight: '24px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    color: theme === 'dark' ? constants_1.color.white : '#8B8B8B',
});
const filesizeText = theme => ({
    margin: 0,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '24px',
    color: theme === 'dark' ? constants_1.color.white : '#DEE0E5',
});
const deleteIconWrapper = {
    position: 'absolute',
    top: 0,
    right: 0,
    width: 24,
    height: 24,
    cursor: 'pointer'
};
const errorText = {
    width: 220,
    color: constants_1.color.redDark,
    margin: 0,
    fontSize: 14,
    marginTop: 12,
    fontWeight: 400,
};
const modalLogsContainer = theme => ({
    width: 500,
    padding: 24,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white
});
const modalHeaderTitle = theme => ({
    margin: 0,
    lineHeight: '24px',
    color: theme === 'dark' ? '#FFFFFF' : 'inherit'
});
const separator275 = {
    height: 275,
    margin: '0 24px',
    borderRight: '1px solid #E7E7E7'
};
const separator300 = {
    height: 310,
    margin: '0 24px',
    borderRight: '1px solid #E7E7E7'
};
const inputItem = {
    padding: 10,
    width: '100%',
    borderRadius: 5,
    border: '2px solid #DEE0E5'
};
const inputWrapper = {
    display: 'flex',
    marginBottom: 24,
    alignItems: 'center',
    justifyContent: 'center',
};
const buttonFont = {
    fontSize: '16px',
    fontWeight: 'normal',
    margin: 0,
    marginLeft: 8,
};
const buttonRefresh = (theme) => ({
    display: 'flex',
    alignItems: 'center',
    borderRadius: 24,
    height: 24,
    width: 24,
    marginRight: 8,
    backgroundColor: theme === 'light' ? constants_1.color.redDark : constants_1.color.buttonDark,
});
exports.default = {
    errorText,
    inputItem,
    browseText,
    uploadText,
    buttonSave,
    buttonFont,
    modalTitle,
    buttonError,
    buttonTitle,
    uploadTitle,
    progressBar,
    buttonReset,
    modalHeader,
    separator275,
    separator300,
    contentStyle,
    inputWrapper,
    filenameText,
    filesizeText,
    buttonSuccess,
    buttonRefresh,
    buttonConfirm,
    modalSubtitle,
    buttonWrapper,
    containerStyle,
    errorIconStyle,
    uploadTypeText,
    filenameWrapper,
    downloadTemplate,
    errorObjectStyle,
    confirmIconStyle,
    uploadDocWrapper,
    modalHeaderTitle,
    uploadZoneWrapper,
    deleteIconWrapper,
    errorContentStyle,
    errorMessageStyle,
    errorSubjectStyle,
    documentsFilename,
    uploadOuterWrapper,
    buttonResetWrapper,
    modalLogsContainer,
    uploadResultWrapper,
    confirmContentStyle,
    buttonConfirmWrapper,
    chooseUploadTypeCard,
    documentsOuterWrapper,
    documentsInnerWrapper,
    chooseUploadTypeWrapper,
    uploadSingleCardWrapper,
    uploadDoubleCardWrapper,
};
